import { css } from 'styled-components'

const extendStylesDropdownOffice = css`
    /* width: 281px; */
    width: 220px;
`

export { extendStylesDropdownOffice }
